const PDFViewer = ({ path }) => {
  return (
    <div>
      <iframe src={path} width="100%" height="500px" />
    </div>
  );
};
export default PDFViewer;
